"use strict";

var _interopRequireDefault = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime@7.17.8@@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_@babel_runtime-corejs2@7.17.8@@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _index = require("@/api/article/index");

var _FooterTabbar = _interopRequireDefault(require("components/FooterTabbar"));

var _voPages = _interopRequireDefault(require("vo-pages"));

require("vo-pages/lib/vo-pages.css");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Article',
  data: function data() {
    return {
      list: [],
      total: 0,
      page: 1,
      loadedAll: false
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  components: {
    VoPages: _voPages.default,
    FooterTabbar: _FooterTabbar.default
  },
  methods: {
    detail: function detail(article) {
      this.$router.push({
        path: "/article/".concat(article.id)
      });
    },
    pullingDown: function pullingDown() {
      this.beforePullDown = false;
      this.page = 1;
      this.getList(false);
    },
    pullingUp: function pullingUp() {
      this.page += 1;
      this.getList();
    },
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var loadMore,
            data,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loadMore = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
                data = {
                  page: this.page
                };
                _context.next = 4;
                return (0, _index.getArticleList)(data).then(function (result) {
                  _this.total = result.data.meta.total;
                  var newList = result.data.data;

                  if (loadMore) {
                    _this.list = _this.list.concat(newList);
                  } else {
                    _this.list = newList;
                  }

                  if (!_this.beforePullDown) {
                    _this.beforePullDown = true;
                  }

                  _this.loadedAll = _this.total <= _this.list.length;
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getList() {
        return _getList.apply(this, arguments);
      }

      return getList;
    }()
  }
};
exports.default = _default;